/**
 * Analytics tracking utilities for the client portal
 * Tracks feature usage, document access, and other user activities
 */

import { API } from '../config/api';

/**
 * Track feature/page usage
 * @param {string} feature - Feature name (e.g., 'dashboard', 'messages', 'documents', 'calendar', 'resources')
 */
export const trackFeatureUsage = async (feature) => {
  try {
    const formData = new FormData();
    formData.append('feature', feature);
    
    await fetch(`${API}/analytics/track-feature`, {
      method: 'POST',
      credentials: 'include',
      body: formData
    });
  } catch (error) {
    // Silently fail - analytics should not break the app
    console.debug('Analytics tracking error:', error);
  }
};

/**
 * Track document access (view or download)
 * @param {string} documentId - The document ID
 * @param {string} action - 'view' or 'download'
 */
export const trackDocumentAccess = async (documentId, action) => {
  try {
    const formData = new FormData();
    formData.append('document_id', documentId);
    formData.append('action', action);
    
    await fetch(`${API}/analytics/track-document-access`, {
      method: 'POST',
      credentials: 'include',
      body: formData
    });
  } catch (error) {
    // Silently fail - analytics should not break the app
    console.debug('Analytics tracking error:', error);
  }
};

/**
 * Track task completion
 * @param {string} taskId - The task ID
 */
export const trackTaskCompletion = async (taskId) => {
  try {
    const formData = new FormData();
    formData.append('feature', 'task_completed');
    formData.append('task_id', taskId);
    
    await fetch(`${API}/analytics/track-feature`, {
      method: 'POST',
      credentials: 'include',
      body: formData
    });
  } catch (error) {
    console.debug('Analytics tracking error:', error);
  }
};

/**
 * Track message sent
 * @param {string} caseId - The case ID
 */
export const trackMessageSent = async (caseId) => {
  try {
    const formData = new FormData();
    formData.append('feature', 'message_sent');
    
    await fetch(`${API}/analytics/track-feature`, {
      method: 'POST',
      credentials: 'include',
      body: formData
    });
  } catch (error) {
    console.debug('Analytics tracking error:', error);
  }
};

export default {
  trackFeatureUsage,
  trackDocumentAccess,
  trackTaskCompletion,
  trackMessageSent
};
